import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import DateTime from "components/DateTime";
import ButtonDefault from "components/DesignComponents/ButtonDefault";
import Tag, { TAG_COLORS, TAG_SIZES } from "components/DesignComponents/Tag";
import { body3SemiBold, body4Regular } from "shared/styles/typography";

import { NewsItemProps } from "./types";

const NewsItem = ({ data, isNew, onClick }: NewsItemProps) => {
    const { gray50, gray100, textPlaceholder } = colors;

    const { t } = useTranslation();

    const { createdAt, id, image } = data;

    const title = t(`Dashboard##news##title##${id}`);

    return (
        <ButtonDefault
            onClick={() => onClick(data)}
            css={css({
                display: "flex",
                justifyContent: "space-between",
                border: `1px solid ${gray100}`,
                borderRadius: "6px",
                padding: "15px",
                columnGap: "8px",
                transition: "background 300ms cubic-bezier(0.4, 0, 0.2, 1)",

                "@media(max-width: 599px)": {
                    flexDirection: "column"
                },

                "&:hover": {
                    background: gray50,
                    cursor: "pointer"
                }
            })}
        >
            <div css={css({ flex: "1" })}>
                <div
                    css={[
                        body4Regular,
                        {
                            display: "flex",
                            alignItems: "center",
                            color: textPlaceholder,
                            marginBottom: "4px",
                            lineHeight: "20px"
                        }
                    ]}
                >
                    <DateTime date={createdAt} format="L" />

                    {isNew && (
                        <Tag
                            size={TAG_SIZES.Tiny}
                            color={TAG_COLORS.Primary}
                            title={t("Dashboard##new")}
                            css={css({
                                pointerEvents: "none",
                                marginLeft: "4px"
                            })}
                        />
                    )}
                </div>

                <div css={body3SemiBold}>{title}</div>
            </div>

            <div
                css={css({
                    width: "126px",
                    height: "84px",

                    "@media(max-width: 599px)": {
                        marginTop: "8px"
                    },

                    "& > img": {
                        width: "100%"
                    }
                })}
            >
                {image ? <img src={image} alt={title} /> : null}
            </div>
        </ButtonDefault>
    );
};

export default NewsItem;
